import React from 'react'
import D_404 from '../../components/D_404'
 function Error()  {
  return (
   
    <D_404/>
   
  )
}
export default Error